import { Component, ChangeDetectionStrategy } from '@angular/core';
import { PetInsuranceData } from "../../models";
import { DataStorageService } from "../../services/data-storage.service";

@Component({
  selector: 'cpf-cancel-insurance-reason-page',
  templateUrl: './cancel-insurance-reason-page.component.html',
  styleUrls: ['./cancel-insurance-reason-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class CancelInsuranceReasonPageComponent {
  petData?:PetInsuranceData;

  constructor(private dataStorageService: DataStorageService) {
    this.petData = this.dataStorageService.selectedData;

    this.dataStorageService.selectedData$.subscribe((data) => {
      this.petData = data;
    })
  }
}
